import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Icon } from "@iconify/react";

const Pageheader = ({ data }) => {
 
    

  return (
    <Container className="bgeYantraCTA p-md-5 p-3 my-5">
      <Row className="align-items-center">
        <Col md={12}>
          <h2 className="text-white text-center" id="headingFontSize">
            {data[0].pageHeaderName}
          </h2>
          <p className="text-white fs-16 text-center" style={{ fontStyle: "italic" }}>
            {data[0].pageParagraphitalic}
          </p>
          <p className="fst-normal text-white fs-6 text-center">{data[0].pageParagraphText}</p>
        </Col>

      </Row>
    </Container>
  );
};

export default Pageheader;
